import React from 'react'
import UnexpectedErrorBoundary from 'components/UnexpectedErrorBoundary'
import { InsightContentSettingType } from 'components/insightContent/types'
import TopAuthorsType from 'components/insightContent/enum/TopAuthorsType'
import RunSearchEffect from '../share/RunSearchEffect'
import InsightTable from '../share/InsightTable'

const Mentions = ({ detailSetting }: { detailSetting: InsightContentSettingType }) => (
  <UnexpectedErrorBoundary>
    <RunSearchEffect detailSetting={detailSetting} postType={TopAuthorsType.MENTIONS}>
      <InsightTable postType={TopAuthorsType.MENTIONS} />
    </RunSearchEffect>
  </UnexpectedErrorBoundary>
)

export default Mentions
